/**

1. initialMasterJSON.ready: this event gives the content of all hotels
2. the dynamic update ajax-call will return the fares of all hotels , another ajax call might be need to retrieve all the fares , as we might not get all the fares in the first call itself.



events:
subcribe:
	initialMasterJSON.ready
fire:
	firstPartialMasterJSON.ready
	finalMasterJSON.ready

	liItem.update
	liItem.delete
	liItem.add



	**/
	!function(module){
		//>>excludeStart("requireTmpl", pragmas.requireTmpl);
		if(window.define) define('hotels/dynamicDataLoader',['hotelBackgroundSearch', 'libs/ct_pubsub'], module)
			else
		//>>excludeEnd("requireTmpl");
	module(CT.hotelBackgroundSearch)
	}(function(hotelBackgroundSearch){
		
		function modifier(respJSON){
			var hotelsList, i, hotel;
			respJSON.of = respJSON.of || {}; //'of' is filled during the price update calls
			respJSON.emi = respJSON.emi || {}; //'emi' is filled during the price update calls
			respJSON.searchType = respJSON.searchType || {}; //'searchType' is filled during the price update calls
	
			//debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug- FOR QA
			respJSON.dbg = respJSON.dbg || {}; //'dbg' is filled during the price update calls
			//debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug-debug- FOR QA
	
			hotelsList = respJSON.ht;
	
	
			if(CT.app == 'dp') {
	
				//add rr details inside each hotel and delete rr from json
				for(i=0;i<hotelsList.length;i++) {
					// TODO: if check added temporarily. remove it - karthik
					hotel = hotelsList[i];
					if(respJSON.rr[hotel.id] != undefined && respJSON.rr[hotel.id].rms.length > 0) {
						$(["oi","rms","pf","ps", "airpf","airps","hotelpf","hotelps","tc"]).each(function(_i,key){
							if(respJSON.rr[hotel.id][key] == 0) {
								hotel[key] = respJSON.rr[hotel.id][key];
							} else {
								hotel[key] = respJSON.rr[hotel.id][key] || '';
							}
						});
	
						/*
						hotel.rms = respJSON.rr[hotel.id].rms;
						hotel.pf = respJSON.rr[hotel.id].pf;
						hotel.ps = respJSON.rr[hotel.id].ps;
						hotel.oi = respJSON.rr[hotel.id].oi;
						*/
					} else {
						hotelsList.splice(i, 1);
						i--;
					}
	
				}
				/*
				_.forEach(hotelsList,function(hotel, index){
					// TODO: if check added temporarily. remove it - karthik
					if(respJSON.rr[hotel.id] != undefined) {
						hotel.rms = respJSON.rr[hotel.id].rms;
						hotel.pf = respJSON.rr[hotel.id].pf;
						hotel.d = respJSON.rr[hotel.id].d;
					} else {
						hotelsList.splice(index, 1);
					}
				});
				*/
				// deleting rr info
				delete respJSON.rr;
				/**
				 * attribute "jsons" its structure has to change from an Array to a Map in the server side.
				 * Till then  doing the convertion of Array to Map here
				 * TODO: remove this block of code later
				 */
				 if(respJSON.fl.jsons instanceof Array){
					 var tempHash = {};
					 _.forEach(respJSON.fl.jsons,function(json){
						 for (var k in json){
							 tempHash[k] = json[k];
						 }
					 });
					 respJSON.fl.jsons = $.extend(true,{},tempHash);
					 delete tempHash;
				 }
	
				// TODO: temp fix for getting intl and roundtrip data - karthik
				function isInternational(){
					var routes = CT.settings.routes, paramsHash = routes.getUrlParams();
					if((paramsHash.origin.indexOf(", IN - ") >= 0) && (paramsHash.destination.indexOf(", IN - ") >= 0)) {
						return false;
					}else{
						return true;
					}
				}
	
				/*
				respJSON.fl.jsons.searchType = respJSON.fl.jsons.searchType||{roundTrip:true}
				respJSON.fl.jsons.searchType.isIntl = isInternational();
				*/
				//For intl modify the json add a if check for is Intl
				if(respJSON.fl.jsons.searchType.isIntl === true && respJSON.fl.jsons.searchType.roundTrip === true){
					flightsList = respJSON.fl.mapping.onward;
					respJSON.fl.mapping["return"] = [];
					_.forEach(flightsList,function(flight,index){
						tmp = flight.c;
						respJSON.fl.mapping.onward[index].c = tmp[0];
						respJSON.fl.mapping["return"].push({"f":respJSON.fl.mapping.onward[index].f,"c":tmp[1]})
					});
					respJSON.fl.crt = respJSON.fl.con;
				}
				// for ctct tracking .
				if(respJSON.fl.jsons.searchType.isIntl){
					window.ct_ct_track = {n:"sr",p:"dpi"};
				}else{
					window.ct_ct_track = {n:"sr",p:"dpd"};
				}
				CT.utils.trackers.page_count();
			}
	
			_.forEach(hotelsList,function(hotel){
				if(hotel.rms && !hotel.priceInfo){	// if priceInfo is sent along with contentInfo json in the first call itself, set hotel.priceInfo .
					hotel.priceInfo = {};
					$(["oi","dcnt","rms","min","max","sdr","perbk","ctslp","recbk","pf","d","ps","airpf","airps","hotelpf","hotelps","tc"]).each(function(_i,key){
						if(hotel[key] == 0) {
							hotel.priceInfo[key] = hotel[key];
						} else {
							hotel.priceInfo[key] = hotel[key] || '';
						}
						delete hotel[key];
					});
				}
			});
			return respJSON;
		}
		
		
		
		/* Obj to store the merger results of SID calls*/
		
		var sidMergerObj = {
			sidRatesResults : {},sidOfferObj : {},sidSearchType : {},sidDebugInfo : {},sidEmiInfo : {},sidPG : {},sidAvgRate:{}, sidModStatus: ""
		}
		
		
		/* Merge all the SID calls to the obj before updating masterJSon*/
		
		function mergeSidResults(priceJSON, view){
			$.extend(sidMergerObj.sidRatesResults, priceJSON.results.ht);
			$.extend(sidMergerObj.sidOfferObj, priceJSON.results.of);
			$.extend(sidMergerObj.sidSearchType, priceJSON.results.searchType);
			$.extend(sidMergerObj.sidAvgRate, priceJSON.results.avgrate);
			$.extend(sidMergerObj.sidEmiInfo, priceJSON.emi);
			$.extend(sidMergerObj.sidDebugInfo,  priceJSON.results.dbg);
			sidMergerObj.sidModStatus = priceJSON.results.isModEnabled;
			if(priceJSON.results.pg)
				window.topLevelRateRules = priceJSON.results.pg;
		}
					
		//	window.funcCount = 0;
		function updateHotelProperties(hotel , mJson , view , badgeCnt ,badgesStat,dodHotelList){
			//	funcCount++;
			var prevHighestUsp = 0 , usp = ['l','c','v'] , tmp ,tmpPtArr = [] ,tmpPt ,tmpDeals,
			htPropertyNamesObj = CT.settings.general.ptypeMap , totRoomNight = Int(CT.cache[CT.settings.currentTab].searchParams.processed.num_nights)*Int(CT.cache[CT.settings.currentTab].searchParams.processed.num_rooms),
			firstRoomTdt ,  rmsPPCnt = 0 ,fcMessage = CT.messages.hotel.cancellationPolicy , badgeTypes = ['wsh', 'bp', 'lbt', 'sdr' ,'abnb'];
			var cache = CT.cache[CT.settings.currentTab].searchParams.processed;
			hotel.baseImageUrl = CT.utils.helperFunctions.getImageUrl(cache.city, window.hotelBaseLink + "/places/hotels", 270, 185);
			var isLoggedIn = CT.utils.readCTAuthCookie();
			// console.log("hotel.baseImageUrl", hotel.baseImageUrl, window.hotelBaseLink)
				//var ctRating = CT.masterJson.get().cr;
				//For Hotel Chain filter create a Cache for storing the chains
				hotel.nm = hotel.nm.trim();
				if( hotel.pil ) {
					// sort the piligrims.
					var piligrims = _.map(hotel.pil, function(v, k){ return {'temple_key': k, 'temple_distance': v}; })
					.sort(function(a, b){ return a.temple_distance - b.temple_distance});
	
					// show the first one.
					var temple_name = mJson.pils[piligrims[0]['temple_key']], 
					m = ('' + piligrims[0]['temple_distance']).match(/\d+\.?\d?/);
	
					var temple_distance = parseFloat(m[0]);
					hotel['distanceString1'] = '<strong>' + temple_distance + 'km </strong>from ' + temple_name;
	
					if(temple_distance * 1000 <= 1000) {
						hotel['distanceString2'] = 'Walking distance from ' + temple_name;
					}
					else if(temple_distance * 1000 >= 2000 && temple_distance * 1000 <= 3000) {
						hotel['distanceString2'] = 'Near ' + temple_name;
					}
					
				}
				
				// filter places 
				if(hotel.id.indexOf("ABNB") != -1){
					hotel.airBnb = true;
					badgesStat["abnb"] = true;
				//	badgeCnt["abnb"] ++;
				if(hotel.priceInfo == undefined){
					CT.cache[CT.settings.currentTab].airBnbUnavailList.push(hotel.id);
				}
			}
			if(window.abTestVal == "a"){
				hotel.shwTn = true;
			}else{
				hotel.shwTn = false;
			}
			hotel.isPriceZero = false; 
				//add ta review message
				if(hotel.tar){
					hotel.tarevm = hotel.tarev + (hotel.tarev > 1 ? CT.messages.hotel.Reviews : CT.messages.hotel.Review);
				}
				
				if(typeof hotelBaseLink != "undefined") {
					hotel.hotelBaseLink = hotelBaseLink;
				}
				
				if(window.countryCode == "in"){
					hotel.taxDisplayText = "Taxes"
				}else{
					hotel.taxDisplayText = "Hotel tax"
				}
				if(hotel.cri == 0 || hotel.cri){
					hotel.yellowUsp = true
					hotel.yellowUspText = mJson.cr[hotel.cri];
				} else if(hotel.yellowUsp === undefined){
					if((hotel.tar && hotel.tar >= 4) && (hotel.tarev && hotel.tarev >= 35) && hotel.sr && hotel.sr != 4 && hotel.sr != 5){
						_.each(usp,function (_usp){
							if(hotel.tad && hotel.tad[_usp] >=4 && hotel.tad[_usp] > prevHighestUsp) {
								hotel.greenUsp = true
								tmp = _usp;
							}
							if(hotel.tad && hotel.tad[_usp])
								prevHighestUsp = hotel.tad[_usp];
						});
						if(tmp)
							hotel.greenUspText = CT.messages.hotel.usp[tmp];
					}
				}
				//remove if tar is less then or equal to zero
				if(hotel.tar && hotel.tar <=0){
					delete hotel.tar;
				}
				if(hotel.tar){
					hotel.taClass = ("" + hotel.tar).replace(".", "");
				}
				
				var hotelV2 = window.hotelModalV2;
				var cityId = mJson.city;
				
				if(hotelV2 && CT.utils.helperFunctions.checkCityId(parseInt(cityId))){
					hotel.modalV2 = window.hotelModalV2;
					hotel.modalV2Url = CT.utils.helperFunctions.openHotelModalV2(hotel.id,undefined,"",hotel.slugId ? hotel.slugId : "");
				}else{
					hotel.modalV2 = false;
					hotel.modalV2Url = "";
				}
				// if (CT.utils.getAbTestCookie("H_D_SRP_TL") === 'a'  && !(window.product === "B2B" || window.companyConfig) && countryCode === "in") {
				// 	// hide left side links here, add style display none
				// 	// style="display: none;"
				// 	hotel.hideLinks = true;
				// }
				if( window.isOldSelectRoomButton ){
					hotel.selectRoomAbTest = false;
					hotel.modalV2 = false;
				} else {
					if(hotel.modalV2 == true && window.selectRoomAbTest == "b"){
						hotel.selectRoomAbTest = true;
					}else{
						hotel.selectRoomAbTest = false
					}
				}
				if(CT.utils.getAbTestCookie("hotels_srp_cta") == 'b' && window.countryCode =='in'){
					hotel.hotels_srp_cta = true;
				}
				else{
					hotel.hotels_srp_cta = false;	
				}
	
				//remove ar if area name not there
				if(hotel.ar && hotel.ar == '')
					delete hotel.ar
				//hotel star rating
				if(hotel.sr == 0) 
					delete hotel.sr;
				hotel.shortID = CT.utils.shortenID(hotel.id);
				//check for lat long
				if(hotel.latlng && hotel.latlng[0] != 0 && hotel.latlng[1] != 0)
					hotel.hasMap = true
				//check for last booked
				if(hotel.sb && hotel.sb.lbt)
					hotel.lastbooked = '<i class="hotelSprite time">&nbsp;</i><small>'+hotel.sb.lbt+'</small>';
				//check for pay at Hotel 
				if(hotel.pp){
					CT.cache[CT.settings.currentTab].isPayAtHotel = true;
					hotel.showPP = true;
				}
				//Villa code
				if(hotel.viw && hotel.viw > 0){
					CT.cache[CT.settings.currentTab].isVillaProp = true;
					hotel.isvilla = {'viw':hotel.viw}
				}
				if( hotel.vip && hotel.vip > 0)
					hotel.isvilla = {'vip':hotel.vip}
				//hpr == hide price// for one room and one night.
				hotel.hpr = CT.cache[CT.settings.currentTab].searchParams.processed.oneRmNdNgt; 
				//Modify Image size
				if(hotel.fim && hotel.id.indexOf("ABNB") == -1){
					hotel.replacedimg = hotel.fim;
					if(!CT.utils.helperFunctions.isCloudinaryEnabled(cache.city)){
						var tmpImg = hotel.fim.split("_w.");
						hotel.replacedimg = tmpImg[0] +"_200x200."+ tmpImg[1].toLowerCase();
						// hotel.replacedimg = tmpImg[0] +"_270x185."+ tmpImg[1].toLowerCase();
					}
				}
				if(CT.cache[CT.settings.currentTab].searchParams.all.country == "IN"){
					hotel.domHotel = true;
				}else{
					hotel.domHotel = false;
				}
				if(hotel.imc == 0){
					hotel.zeroImages = true;
				}else{
					hotel.zeroImages = false;
				}
				if(hotel.vts && hotel.vts == "Y" && window.enable360){
					hotel.vtsEnabled = true
					window.vtsShown = true;
				}
				//add property type class name
				if (hotel.pt && hotel.pt.length > 0 && !hotel.pt[0].code) {
					tmpPtArr = [];
					tmpPt = hotel.pt.length;
					for(var i=0;i<tmpPt;i++) {
						tmpPtArr.push({ code: hotel.pt[i], name: htPropertyNamesObj[hotel.pt[i]] });
					}
					hotel.pt = tmpPtArr;
				}
				//Modify hotel obj for Dateless search
				if(CT.cache[CT.settings.currentTab].searchParams.processed.dateLessSearch){
					hotel.priceInfo = {};
					hotel.priceInfo["rms"] = [];
					if(hotel.low === 0){
						hotel.isPriceZero = true;
					}
					hotel.priceInfo["rms"].push({'tot' : hotel.low});
				}
				//Hotel Chain Utitlities
				if(CT.cache[CT.settings.currentTab].hotelChains){
					if(hotel.ch!="None"){
						if(CT.cache[CT.settings.currentTab].hotelChains[hotel.ch])
							CT.cache[CT.settings.currentTab].hotelChains[hotel.ch].count++;
						else{
							CT.cache[CT.settings.currentTab].hotelChains[hotel.ch]={};
							CT.cache[CT.settings.currentTab].hotelChains[hotel.ch].count=1;
							CT.cache[CT.settings.currentTab].hotelChains[hotel.ch].name=hotel.ch;
						}
					}
				}
				if(hotel.op && hotel.op == true){
					var tipsyOpHtml = CT.to_html('OpaqueTipsyTpl', hotel);
					hotel.tipsyMarkup = tipsyOpHtml;
					//Add locality id if Opaque
					hotel.locId=CT.utils.checkOpaqueHotels(hotel.ar);
				}
				//Hotel PriceInfo modifications
				if (hotel.priceInfo) {
					if(hotel.priceInfo.sup){
						var s = hotel.priceInfo.sup.replace(/:/g,'');
						var _sup = mJson.dbg.sup
						_.each(_sup, function (supObj,supVal){
							if(s == supVal){
								hotel.dbgName = _.keys(supObj)[0]
								return ;
							}
						});
	
					}
					
					firstRms = hotel.priceInfo.rms[0];
					//hotel.priceInfo.rms[0].ismod
					//console.log('========firstRms========',hotel)
					//For testing purpose
					// firstRms.stpd = {stp: 10000,
				 //            op: 18,
				 //            tot: 5400,
				 //            d: 2600
				 //          }
	
					//hotel.priceInfo.stp = 10000 ; //Hardcoding stp value for testing
					var discount = firstRms.d;
	
					if(window.enableNewStpFlow && window.productCode != "AG" && firstRms.stpd && firstRms.stpd.stp){
						discount = firstRms.stpd.stp - firstRms.tot;
					}
					/*if(hotel.op && hotel.op == true && mJson.avgrate[hotel.ar]){
						var avgRate = mJson.avgrate[hotel.ar][hotel.sr]
						hotel.opAvgFmt = CT.utils.formatForCurrency(avgRate)
					}*/
					if(parseInt(firstRms.tot) <= parseInt(window.budgetBadgeFilter.minBudget)){
						badgeCnt["budgetHotelCnt"]++;
						hotel.isBudget = true;
					}else{
						hotel.isBudget = false;
					}
					
					if(window.taxAbTest === 'a'){
						var tavg = firstRms.avg;
						var roomNights = Int(CT.cache[CT.settings.currentTab].searchParams.processed.num_nights)*Int(CT.cache[CT.settings.currentTab].searchParams.processed.num_rooms);
						firstRms.avg -= firstRms.t;
						view.getDiscountMarkup(firstRms.tot, discount, hotel, mJson);
						if(discount > 0)
							hotel.oamt = CT.utils.formatForCurrency(firstRms.tot + discount, false, null, false);
						firstRms.avg = tavg;
						if(firstRms.t != undefined && ((window.productCode == "AG" && firstRms.t > 0) || (window.productCode !="AG" && firstRms.t >= 0 ))){
							hotel.showTaxLink = true;
							if(window.taxAbTest_A == 'b'){
								hotel.taxAbTest_A = true;
							}
							if(window.productCode == "AG") {
								hotel.taxMarkupPerRoom = CT.utils.formatForCurrency(firstRms.t);
								hotel.taxMarkupTotal = CT.utils.formatForCurrency(firstRms.t * roomNights+100);
								hotel.totalWithoutTaxfmt = CT.utils.formatForCurrency(firstRms.tot - firstRms.t * roomNights, false, null, false);
							}else{
								var totalTax = firstRms.t + firstRms.st + firstRms.sbc + firstRms.kkc;
								//Debit tax from wallet balance
								if(mJson && mJson.wallet && mJson.wallet.hasBalance && mJson.wallet.remainingWalletBalance > 0){
									if(mJson.wallet.remainingWalletBalance >= totalTax){
										totalTax = 0;
									} else if(mJson.wallet.remainingWalletBalance < totalTax) {
										totalTax = totalTax - mJson.wallet.remainingWalletBalance;
									}
									delete mJson.wallet.remainingWalletBalance;
								}
								if(totalTax > 0){
									hotel.taxMarkupPerRoom = CT.utils.formatForCurrency(totalTax);
									hotel.taxMarkupTotal = CT.utils.formatForCurrency((totalTax) * roomNights);
									hotel.totalWithoutTaxfmt = CT.utils.formatForCurrency(firstRms.tot - (totalTax) * roomNights, false, null, false);
								}else{
									hotel.showTaxLink = false;
									hotel.taxAbTest_A = false;	
								}
										
							}
							if(discount > 0){
								if(window.productCode == "AG") {
									hotel.oamtWithoutTaxfmt = CT.utils.formatForCurrency((firstRms.tot + discount) - firstRms.t * roomNights, false, null, false);
								}else{
									hotel.oamtWithoutTaxfmt = CT.utils.formatForCurrency((firstRms.tot + discount) - (firstRms.t + firstRms.st + firstRms.sbc + firstRms.kkc) * roomNights, false, null, false);
								}
							}else {
								hotel.oamtWithoutTaxfmt = "";
							}
						}
					}
					else{
						view.getDiscountMarkup(firstRms.tot, discount, hotel, mJson);
					}
					
					var dealsObjArr = [];
					for(var i=0;i<hotel.priceInfo.rms.length;i++){
						var rms = hotel.priceInfo.rms[i];
							if(rms.spl && !hotel.spl){// for CP special rates
								hotel.spl = true;
							}
							if(rms.fc && !hotel.fc){//free cancellation for CHMM
								hotel.fc = true;
								hotel.fcMsg = fcMessage;
								CT.cache[CT.settings.currentTab].isFc = true
							}
							/*if(hotel.id == "314551" || hotel.id == "1338878" || hotel.id == "306820"){
								rms.dod = true;
							}*/
							if(rms.dod == true){
								//console.log(hotel);
								hotel.dod = true;
								dodHotelList.push(hotel.id);
							}
							/*if(rms.oi && rms.oi.length > 0){
								for(var k=0;k<rms.oi.length;k++){
									dealsObjArr.push(rms.oi[k]);
								}
							}*/
							if(hotel.hpr == true) rms.hpr = true;
							if(hotel.priceInfo.rms && rms.rm){
								if(hotel.priceInfo.sup) {
									rms.rm = rms.rm.replace(/,/g,',<br>')
									rms.showAvgForDebug = CT.utils.formatForCurrency(rms.avg - rms.t) +' + '+ CT.utils.formatForCurrency(rms.t);
								}
								//For postpay chmm
								if(rms.pp && rms.pp === 1){
									rms.showPPChmm = true;
									rmsPPCnt++;
								}
								// for post pay hotels, hide tax info. so create a property and pass it to getRmsMarkup
								rms.showTtd = true;
								rms.bfo=false;
								if(hotel.bfo){
									rms.showTtd = false;
									rms.bfo = true;
								}
							}
						}
						
						//deal info
						if ((hotel.priceInfo.oin && hotel.priceInfo.oin.length > 0)) {
							//dealsObjArr.unshift(hotel.priceInfo.oi)
							hotel.offerObjArr = _.uniq(hotel.priceInfo.oin);
							hotel.offerObj = []
							//hotel.priceInfo.oc = hotel.offerObjArr.length;
							for(var k=0;k<hotel.offerObjArr.length;k++){
								var tmpDeals = mJson.of[hotel.offerObjArr[k]];
								var shwDeal = k == 0?true:false;
								// if (CT.utils.getAbTestCookie("H_D_SRP_TLM") === 'b'  && !(window.product === "B2B" || window.companyConfig) && countryCode === "in") {
								// 	shwDeal = false;
								// }
								if(tmpDeals.lnk){
									hotel.offerObj.push({"dealText":tmpDeals.hd,"dealLink":tmpDeals.lnk,"shwDeal":shwDeal,"isDealLink":true})
									//hotel.displayOnlyRule = true;
								}else{
									hotel.offerObj.push({"dealText":tmpDeals.hd,"shwDeal":shwDeal,"isDealLink":false})
								}
								
							}
							var tmpDeals = mJson.of[hotel.priceInfo.oi];
							hotel.dealI = tmpDeals.hd;
							if(tmpDeals) {
								if(tmpDeals.lnk){
									hotel.dealLink = tmpDeals.lnk;
								}
								//this attribute is used in deal filters
								hotel.displayOnlyRule = false;
							}else {
								hotel.displayOnlyRule = true;
							}
							if(CT.subProd == undefined){
								hotel.priceInfo.oc = hotel.priceInfo.oin.length;
							}
						}
						if(CT.subProd && CT.subProd == "wg" && hotel.dealI){
							if(hotel.dealI.split(" ")[0].toLowerCase() == "upto" || hotel.dealI.split(" ")[0].toLowerCase() == "flat"){
								hotel.dontShwDeal = true;
							}else{
								hotel.dontShwDeal = false;
							}
						}
						//deal count
						if((tmpDeals = hotel.priceInfo.oc) && tmpDeals > 1) {
							tmpDeals = tmpDeals - 1;
							hotel.dcnt = tmpDeals + " more " + (tmpDeals > 1 ? 'deals':'deal');
						}
						
						if(hotel.bfo && firstRoomTdt){
							hotel.tdtfmt = firstRoomTdt;
						}
						if(window.productCode == "CP"){
							if(hotel.priceInfo.pvs) hotel.sb.pvs = true;
							hotel.badgesMup = view.getBadgesMarkup(hotel.sb);
						if(hotel.priceInfo.pvs) delete hotel.sb.pvs;//@todo it might create performace issue, if it is talk to Kedar and move PVS to some other place.
					}else{
						hotel.badgesMup = view.getBadgesMarkup(hotel.sb);
					}
					if(window.companyId) {
						hotel.companyId =  window.companyId;
					}
					hotel.rmtc=firstRms.rmtc;
					hotel.rtc=firstRms.rtc;
					//TODO:: Please uncomment blow line and commit false statment.
					if( (!window.product && window.product != "B2B") && !window.isWL && window.isModEnabledFormUI ){
						if ( isLoggedIn ){
							var isLoggedUserStatus = window.localStorage && window.localStorage.getItem("__ismod__diff__msg");
							if( isLoggedUserStatus ) {
								hotel.justLoggedIn = firstRms.ismod ? firstRms.ismod : false;
								hotel.ismod = firstRms.ismod ? firstRms.ismod : false;
							} else {
								hotel.justLoggedIn = false;
								hotel.ismod = firstRms.ismod ? firstRms.ismod : false;
							}
						} else {
							hotel.showModLock = firstRms.showModLock ? firstRms.showModLock : false;
							// hotel.showModLock = true;
						}
					}
					// hotel.ismod=true;
					//handle trusted hotel case
					if (hotel.priceInfo.tc)
						hotel.trustedH = true;
					if(hotel.priceInfo.oi && !hotel.displayOnlyRule) {
						badgeCnt.deals++
					}
					//set if even a single hotel is having savings in it
					if (badgesStat && !badgesStat.deals && hotel.priceInfo.oi && !hotel.displayOnlyRule)
						badgesStat.deals = true;
				}
				if(badgesStat){
					_.forEach(badgeTypes, function(name) {
						if(!badgesStat[name] && hotel.sb && hotel.sb[name])
							badgesStat[name] = true;
						if(hotel.sb && hotel.sb[name] && hotel.priceInfo)
							badgeCnt[name] ++
					});
				}
				
				
				/*if(window.twoCol){
					if(CT.cache[CT.settings.currentTab].searchParams.all.country == "IN"){
						if(CT.masterJson.get().hmn == "Business"){
							hotel.amenities = CT.to_html('AmenitiesTpl', { amTwoColBussIcons : CT.utils.helperFunctions.getHotelAmenities(hotel.am) });
						}else{
							hotel.amenities = CT.to_html('AmenitiesTpl', { amTwoColLeisureIcons : CT.utils.helperFunctions.getHotelAmenities(hotel.am) });
						}
					}else{
						hotel.amenities = CT.to_html('AmenitiesTpl', { amTwoColIntlIcons : CT.utils.helperFunctions.getHotelAmenities(hotel.am) });
					}
					
				}else{*/
					
					hotel.amenities = CT.to_html('AmenitiesTpl', { amIcons: CT.utils.helperFunctions.getHotelAmenities(hotel.amn) });
				//}
				
				if(CT.subProd == "wg"){
					var destObj = _.filter(mJson.wd.d, { 'i': hotel.c })
					
					if(hotel.c){
						if(destObj && destObj.length > 0){
							hotel.city = destObj[0].n;
						}
					}
					if((hotel.tt == 0 || hotel.dt == 0) && destObj && destObj.length > 0 && destObj[0].n != mJson.cnm){
						if(hotel.tt == 0)
							hotel.tt = destObj[0].t;
						if(hotel.dt == 0)
							hotel.dt = destObj[0].d;
					}
	
					if(hotel.tt){
						var hrs = Math.ceil( hotel.tt / (60))
						hotel.tt_mod = hrs > 1 ? hrs+" hrs" : "1 hr";
					}
					if(hotel.dth && hotel.dth.length > 0){
						hotel.dth_mod = mJson.wd.dth[hotel.dth[0]];
					}
					if(hotel.hth && hotel.hth.length > 0){
						hotel.specialTag = [];
						for(var i=0;i<hotel.hth.length;i++){
							if(i <=2){
								if(CT.settings[CT.app][CT.subProd].hotelsThemeTextMap[hotel.hth[i]]){
									hotel.specialTag.push({ tagName: CT.settings[CT.app][CT.subProd].hotelsThemeTextMap[hotel.hth[i]].cls, tagText: CT.settings[CT.app][CT.subProd].hotelsThemeTextMap[hotel.hth[i]].text })
								}
							}
						}
					}
					if(hotel.dt){
						hotel.dt_mod = Math.floor(hotel.dt) !=0 ?Math.floor(hotel.dt)+" km" : "";
					}
					
				}
				if(window.altFilters == "true"){
					hotel.altFilters = true;
				}

				
			}
			
			
			/**
				append the newly recieved price element to the existing master json
				**/
				function updater(sidMergerObj, view){
					var priceMap = sidMergerObj.sidRatesResults
					var mJson = CT.masterJson.get(), 
					
					badgeCnt = CT.cache[CT.settings.currentTab].badgeCnt,
					dodHotelList = CT.cache[CT.settings.currentTab].dodHotelList,
					badgesStat = CT.cache[CT.settings.currentTab].badgesStat;
					CT.utils.setCurrency(masterJSON.searchType);
					
					mJson.of = {},
					mJson.searchType = {},
					mJson.emi = {},
					mJson.dbg = {},
					mJson.avgrate = {}

					$.extend(mJson.of, sidMergerObj.sidOfferObj);
					$.extend(mJson.searchType, sidMergerObj.sidSearchType);
					$.extend(mJson.emi, sidMergerObj.sidEmiInfo);
					$.extend(mJson.dbg,  sidMergerObj.sidDebugInfo);
					$.extend(mJson.avgrate,  sidMergerObj.sidAvgRate);
					mJson.isModEnabled = sidMergerObj.sidModStatus;
					//Create the Hotel Chain Cache
					CT.cache[CT.settings.currentTab].hotelChains={};
					_.forEach(mJson.ht,function(hotel){
						if(priceMap[hotel.id]){
							if(priceMap[hotel.id].rms) {
								hotel.priceInfo = priceMap[hotel.id]
								if(priceMap[hotel.id].sb) {
									hotel.sb = priceMap[hotel.id].sb
									delete hotel.priceInfo.sb
								}
	
								if(priceMap[hotel.id].pp){
									hotel.pp = priceMap[hotel.id].pp
									delete hotel.priceInfo.pp
								}
								if(priceMap[hotel.id].bfo){
									hotel.bfo = priceMap[hotel.id].bfo
									delete hotel.priceInfo.bfo
								}
							}
							else{
								hotel.sb = priceMap[hotel.id].sb;
								hotel.priceInfo = undefined;
								hotel.totfmt = undefined;
								hotel.totfmtPerRoom = undefined;
							}
							if(priceMap[hotel.id].tags){
								hotel.tags=priceMap[hotel.id].tags
							}
						}
						updateHotelProperties(hotel , mJson , view , badgeCnt ,badgesStat,dodHotelList);
					});
					//For hotel Chains use sorted Chain list
					if(window.chunkyFiltersEnabled){
						CT.cache[CT.settings.currentTab].sortedHotelChains=_.sortBy(CT.cache[CT.settings.currentTab].hotelChains,function(chain){
							return chain.count;
					}).reverse(); //For Convinience Sorted in Desc	
					   //Update the settings to create filter and cache to store already added chains
					   var sortedChains=CT.cache[CT.settings.currentTab].sortedHotelChains;
					   CT.settings.hotel.filter.chain.elements=[];
					   CT.cache[CT.settings.currentTab].prevAddedchains=[];
					   var counter=1;var excludes=['Zo Rooms']
					   var maxCount =  10;
					   for(var i=0;i<sortedChains.length;i++){
						   if(counter>maxCount) return //stop chain if counter execeeds 3
							   if(excludes.indexOf(sortedChains[i].name)==-1){
								   counter++;
								   var elementObj={
									   "chainName":sortedChains[i].name,
									   "value":sortedChains[i].name,
									   "chainCount":sortedChains[i].count
								   };
								   CT.settings.hotel.filter.chain.elements.push(elementObj)
								   CT.cache[CT.settings.currentTab].prevAddedchains.push(elementObj.chainName);
							   }
						   }
					   }		
					   badgesStat.cnt = badgeCnt;
					   CT.masterJson.set(mJson);
					
				// need not to return the masterJSON, as the master json is past by reference here.
				return;
	
			}
	
	
			function createHandlerFor(view , callbackParams){
				return function(respJson){
					if ( typeof respJson == "string") {
						try {
							respJson = JSON.parse(respJson);
						} catch(e) {
						}
					}
					var makeAirBnbCall = false;
						
					
					if(callbackParams && callbackParams.airBnb && callbackParams.airBnb == true){
						CT.settings[CT.app]["airBnb"].urls.updateCall = respJson.cbu;
						CT.settings[CT.app]["airBnb"].urls.updateCallTimer = respJson.cbt?respJson.cbt:0;
						makeAirBnbCall = callbackParams.airBnb == true && CT.settings[CT.app]["airBnb"].urls.updateCall != undefined?true: false;
						if(respJson.cbu == undefined){
							CT.settings.hotel.airBnbRatesCallDone = true;
						}
						
					}else{
						if(!respJson.progress && !respJson.retry && !masterJSON.wallet.progress){
							CT.settings.hotel.hotelRatesCallDone = true;
							CT.settings.hotel.priceJSON = null;
						}else {
							CT.settings.hotel.priceJSON = respJson;
						}
					}
					if(CT.app == 'dp') {
						priceJson = modifier(respJson);
					}else{
						priceJson = respJson;
					}
					//priceJson = modifier(respJson);
					
					if(priceJson.results && priceJson.results.ht){
						//CT.settings.hotel.hotelPropertiesUpdated = true;
						//updater(priceJson, view);
						mergeSidResults(priceJson, view);
					} else if(!CT.cache[CT.settings.currentTab].searchParams.processed.dateLessSearch && CT.settings.hotel.updateCallIndex == 1) {
						showDynamicCallFailMsg(500);
					}
					if(makeAirBnbCall == true){
						setTimeout(function(){
							callbackParams.airBnbCall = true;
							fetch(CT.settings[CT.app]["airBnb"].urls.updateCall, CT.settings.hotel.sid, undefined, callbackParams).done(createHandlerFor(view , callbackParams)).fail(function(error){showDynamicCallFailMsg(error, callbackParams)})
						},CT.settings[CT.app]["airBnb"].urls.updateCallTimer)
					}else{
						if(respJson.retry){
							if(CT.settings.localhost){
								fetch(respJson.url, CT.settings.hotel.sid,true).done(createHandlerFor(view)).fail(function(error){showDynamicCallFailMsg(error)})
							}else{
								fetch(CT.settings.hotel.urls.updateCall,CT.settings.hotel.sid,true).done(createHandlerFor(view)).fail(function(error){showDynamicCallFailMsg(error)})
							}
						}else{
							if (respJson.progress) {
								view.fire('partialResults.ready');
								if(CT.settings.localhost){
									fetch(respJson.url, CT.settings.hotel.sid).done(createHandlerFor(view)).fail(function(error){showDynamicCallFailMsg(error)})
								}else{
									fetch(CT.settings.hotel.urls.updateCall,CT.settings.hotel.sid).done(createHandlerFor(view)).fail(function(error){showDynamicCallFailMsg(error)})
								}
							} 
						}
					}
					
					if(CT.settings.hotel.airBnbRatesCallDone && (CT.settings.hotel.hotelRatesCallDone || CT.subProd == "airBnb")){
						// console.log(sidMergerObj)
						updater(sidMergerObj,view);
						var mJson = CT.masterJson.get();
						mJson.err = respJson.results ? respJson.results.err : "";
						CT.masterJson.set(mJson);
						if(window.twoCol == true && CT.subProd != "wg"){
							/*$.when(
								$.getScript('/javascripts/widgets/royal-slider.js')
							).then(function(){
								CT.utils.helperFunctions.getCityImages();
							})*/
							CT.utils.helperFunctions.getCityImages();
						}
						/*if(!CT.settings.hotel.hotelPropertiesUpdated){
							updateHotelObj(mJson , view)
						}*/
						view.$el.trigger('finalMasterJSON.ready');
					}
					
					/*if(respJson.retry){
						if(CT.settings.localhost){
							fetch(respJson.url, CT.settings.hotel.sid,true).done(createHandlerFor(view)).fail(function(error){showDynamicCallFailMsg(error)})
						}else{
							if(respJson.progress != false || respJson.retry){
								fetch(CT.settings.hotel.urls.updateCall,CT.settings.hotel.sid,true).done(createHandlerFor(view)).fail(function(error){showDynamicCallFailMsg(error)})
							}
							
						}
					}else{
						if (respJson.progress) {
							view.fire('partialResults.ready');
							if(CT.settings.localhost){
								fetch(respJson.url, CT.settings.hotel.sid).done(createHandlerFor(view)).fail(function(error){showDynamicCallFailMsg(error)})
							}else{
								if(respJson.progress != false){
									fetch(CT.settings.hotel.urls.updateCall,CT.settings.hotel.sid).done(createHandlerFor(view)).fail(function(error){showDynamicCallFailMsg(error)})
								}
								if(callbackParams && callbackParams.airBnb && callbackParams.airBnb == true && makeAirBnbCall == true){
									callbackParams.airBnbCall = true;
									fetch(CT.settings.hotel.airBnbUrls.updateCall, CT.settings.hotel.sid, undefined, callbackParams).done(createHandlerFor(view , callbackParams)).fail(function(error){showDynamicCallFailMsg(error, callbackParams)})
								  }
							}
						} else {
							var mJson = CT.masterJson.get();
							mJson.err = respJson.results.err;
							CT.masterJson.set(mJson);
							/*if(window.twoCol == true){
								$.when(
									$.getScript('/javascripts/widgets/royal-slider.js')
								).then(function(){
									CT.utils.helperFunctions.getCityImages();
								})
							}*/
							/*view.$el.trigger('finalMasterJSON.ready');
						}
					}*/
				}
			}
	
			/*
			 * if an of the dynamic call fails then show server error message
			 */
			 function showDynamicCallFailMsg(err) {
				//alert(err.status)
				if(err.status != 0 || err == 500)
					CT.fire('search.disambError', [500]);
			}
	
			/**
				use the master JSON to form the url and fetch the price list from server
				**/
				function fetch(url, id, retry, callbackParams){
					if(callbackParams && callbackParams.airBnb == true && callbackParams.airBnbCall == true){
						var finalUrl = url
					}else{
						if(retry != undefined && retry == true){
							CT.settings.hotel.updateCallIndex--;
							CT.settings.hotel.sidResultsCallCount++;
						}else{
							CT.settings.hotel.sidResultsCallCount = 1;
						}
						var finalUrl = url.replace("${sid}",id).replace("${index}", CT.settings.hotel.updateCallIndex++).replace("${count}", CT.settings.hotel.sidResultsCallCount);
					$('body').removeAttr('data-busy') // pre-rendering is done. Now the modify search button can be clicked
					
				}
				return $.ajax(finalUrl)
			}
	
	
			
	
	
	
			/**
			 * @desc Invoked when this module is instansiated, which modifies the json and triggers the fetch from server
			 * @param respJSON - This is the initial response json from the results ajax call. This is set in CT.cache[CT.settings.currentTab].json (in results file)
			 */
			 function init(respJSON, newSearchResView,callbackParams){
				
				 if(CT.app == 'dp') {
					 masterJSON = modifier(respJSON);
				 }else{
					 masterJSON = respJSON;
				 }
				//masterJSON = modifier(respJSON);
				if(!window.amenitiesMap){
					window.amenitiesMap = _.map(masterJSON.aml,function(serverMap){
						var obj = _.find(CT.settings.general.amenitiesMap,function(clientMap){
							if(serverMap.bit == clientMap.bit){
								return clientMap;
							}
						});
						
						serverMap.title = obj.title;
						serverMap.class = obj.class;
						return serverMap;
					});	
				}
				
				var makeAirBnbCall = callbackParams && callbackParams.airBnb == true && CT.settings[CT.app]["airBnb"].urls.updateCall != undefined?true: false;
				if(respJSON.progress != false || makeAirBnbCall == true){
					if(CT.settings.localhost){ // to be removed inconsistency in the JSON, that's y added---Apurv
						CT.settings.hotel.updateCallIndex = 1;
					CT.settings.hotel.hotelRatesCallDone = false;
					fetch(respJSON.url, respJSON.sid).done(createHandlerFor(newSearchResView)).fail(function(error){showDynamicCallFailMsg(error)})
				}
				else{
					CT.settings.hotel.updateCallIndex = 1;
					CT.settings.hotel.hotelRatesCallDone = false;
					//Default object for wallet
					masterJSON.wallet = { 
						progress:false,
						enabled:false,
						show:false,
						"wallet_balance": 0
					};
					//Check if all flag required to apply creative pricing is enabled or not.
					var isValidWalletUser = CT.utils.checkUnConfirmedUser() || CT.utils.readCTAuthCookie();
					var ABTestCookies = CT.utils.getAbTestCookie();
					var creativePricingAB = ABTestCookies && ABTestCookies.creativePricingAB === 'b';
	
					masterJSON.wallet.enableCreativePricing = !window.isWL && window.product != "B2B" && window.enableCreativePricing && creativePricingAB && CT.utils.helperFunctions.isDomesticHotel();
					if(isValidWalletUser && masterJSON.wallet.enableCreativePricing){
						masterJSON.wallet.progress = true;
					}
					
					if(callbackParams && callbackParams.isDateLess && callbackParams.isDateLess == true){
						var callback = function(wallet){
							masterJSON.wallet = wallet || masterJSON.wallet;
							masterJSON.err = {};
							masterJSON.searchType = {};
							updateHotelObj(masterJSON , newSearchResView)
							CT.masterJson.set(masterJSON);
							// Add AB test flag and only enable for B2C flow
							CT.utils.helperFunctions.getCityImages();
							newSearchResView.$el.trigger('finalMasterJSON.ready');
						}
						if(masterJSON.wallet.progress){
							CT.utils.wallet.setWalletObject(masterJSON.wallet, callback);	
						} else {
							callback();
						}
					}else{
						var priceJson = hotelBackgroundSearch.get("sidResults");
						var isRatesResultsAvailable = priceJson && !priceJson.progress && !priceJson.retry;
						var hotelDataHandler = createHandlerFor(newSearchResView);
						if(masterJSON.wallet.progress){
							CT.utils.wallet.setWalletObject(masterJSON.wallet, function(wallet){
								masterJSON.wallet = wallet;
								if(isRatesResultsAvailable){
									hotelDataHandler(priceJson);
								} else if(CT.settings.hotel.priceJSON){
									hotelDataHandler(CT.settings.hotel.priceJSON);
								} 
							});
						}
						//Same if condition is duplicated 2 times - Mahipat
						if(isRatesResultsAvailable){
							hotelDataHandler(priceJson);
						} 
						else if(respJSON.progress != false && CT.subProd != "airBnb"){
							fetch(CT.settings.hotel.urls.updateCall, CT.settings.hotel.sid).done(createHandlerFor(newSearchResView)).fail(function(error){showDynamicCallFailMsg(error)});
						}
						if(callbackParams && callbackParams.airBnb && callbackParams.airBnb == true &&  makeAirBnbCall == true){
							setTimeout(function(){
								callbackParams.airBnbCall = true;
								fetch(CT.settings[CT.app]["airBnb"].urls.updateCall, CT.settings.hotel.sid , undefined, callbackParams).done(createHandlerFor(newSearchResView , callbackParams)).fail(function(error){showDynamicCallFailMsg(error, callbackParams)})
							},CT.settings[CT.app]["airBnb"].urls.updateCallTimer)
						}
					}
				}
			}
		}
		
		function updateHotelObj(firstFewHotels, newSearchResView){
			var masterJSON = CT.masterJson.get(),
			badgeCnt = CT.cache[CT.settings.currentTab].badgeCnt,
			dodHotelList = CT.cache[CT.settings.currentTab].dodHotelList,
			badgesStat = CT.cache[CT.settings.currentTab].badgesStat;
			CT.utils.setCurrency(masterJSON.searchType)
			CT.cache[CT.settings.currentTab].hotelChains={};
			if(masterJSON.aml){	
				var obj = _.map(masterJSON.aml,function(serverMap){
							var obj = _.find(CT.settings.general.amenitiesMap,function(clientMap){
							if(serverMap.bit == clientMap.bit){
								return clientMap;
							}
						});
			
				serverMap.title = obj.title;
				serverMap.class = obj.class;
				return serverMap;
			});
			}
			
			_.forEach(firstFewHotels.ht,function(hotel){
				updateHotelProperties(hotel , masterJSON , newSearchResView , badgeCnt ,badgesStat,dodHotelList)
			});
			
			if(!(masterJSON && masterJSON.pils && _.keys(masterJSON.pils).length == 1))
				$('nav.sorters').find(".distanceSort").closest("li").hide();
			//For chunky filters.update the chain filter
			if(window.chunkyFiltersEnabled){
				CT.cache[CT.settings.currentTab].sortedHotelChains=_.sortBy(CT.cache[CT.settings.currentTab].hotelChains,function(chain){
					return chain.count;
					}).reverse(); //For Convinience Sorted in Desc	
					   //Update the settings to create filter and cache to store already added chains
					   var sortedChains=CT.cache[CT.settings.currentTab].sortedHotelChains;
					   CT.settings.hotel.filter.chain.elements=[];
					   CT.cache[CT.settings.currentTab].prevAddedchains=[];
					   var counter=1;var excludes=['Zo Rooms']
					   for(var i=0;i<sortedChains.length;i++){
						   if(counter>3) return //stop chain if counter execeeds 3
							   if(excludes.indexOf(sortedChains[i].name)==-1){
								   counter++;
								   var elementObj={
									   "chainName":sortedChains[i].name,
									   "value":sortedChains[i].name,
									   "chainCount":sortedChains[i].count
								   };
								   CT.settings.hotel.filter.chain.elements.push(elementObj)
								   CT.cache[CT.settings.currentTab].prevAddedchains.push(elementObj.chainName);
							   }
						   }
					   }		
	
				   }
	
				   CT.subscribe('initialMasterJSON.ready', init)
	
				   CT.subscribe('updateHotelObj', updateHotelObj)
	
				   return;
	
				})
	
	;
